function HomeContent() {
  return (
    <div className="pt-16 px-4 md:px-8 lg:px-16 max-w-5xl mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center md:text-left">
        मुखपृष्ठ
      </h2>
      <p className="text-gray-700 text-base md:text-lg leading-relaxed">
        श्री शिव शंभो चॅरिटेबल ट्रस्ट (श्री शिव शंभो महादेव मंदिर) हे शक्ती सेवा
        आणि सामाजिक बांधिलकी या मूल्यांवर आधारित एक विश्वासार्ह धार्मिक व
        सामाजिक संस्था आहे भगवान शिवाच्या उपासनेद्वारे अध्यात्मिक उन्नती धार्मिक
        परंपरांचे जतन आणि समाजोपयोगी उपक्रम राबविणे हे आमचे प्रमुख ध्येय आहे.
      </p>
    </div>
  );
}

export default HomeContent;
